// extracted by mini-css-extract-plugin
export default {"container":"T0-z","list":"U0-z"};